import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { connect } from 'react-redux';

import { listPLaygrounds } from './../../ducks/selectors';
import { fetchPlaygrounds } from './../../ducks/playgrounds';
import Link from './../../components/Link';
import AdminPageShell from '../../components/admin/AdminPageShell';

class Playgrounds extends Component {
  static propTypes = {
    playgrounds: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    userRole: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    fetchPlaygrounds: PropTypes.func,
  };

  componentDidMount() {
    if ((!this.props.playgrounds || this.props.playgrounds.length === 0) && this.props.fetchPlaygrounds) {
      this.props.fetchPlaygrounds().catch(() => {});
    }
  }

  redirectToPlayground = id => this.props.history.push(`/playground/${id}`)

  constructor(props) {
    super(props);
    this.state = {
      cityFilter: 'all',
      orderBy: 'name',
      order: 'asc',
    };
    this.orderBy = this.orderBy.bind(this);
  }

  orderBy(field) {
    if (field === this.state.orderBy) {
      this.setState({ order: this.state.order === 'desc' ? 'asc' : 'desc' });
    } else {
      this.setState({ orderBy: field });
    }
  }

  render() {
    const { playgrounds, classes, userRole } = this.props;
    
    const isAdmin = userRole === 'administrator';
    const isModerator = userRole === 'moderator';
    
    // Получаем уникальные города из площадок (если они есть)
    const uniqueCities = playgrounds && playgrounds.length > 0 
      ? _.uniq(playgrounds.map(playground => playground.city).filter(city => city))
      : [];
    
    // Фильтруем площадки по городу
    let filteredPlaygrounds = playgrounds || [];
    if (this.state.cityFilter !== 'all' && filteredPlaygrounds.length > 0) {
      filteredPlaygrounds = filteredPlaygrounds.filter(playground => playground.city === this.state.cityFilter);
    }
    
    // Сортируем площадки
    const orderedPlaygrounds = filteredPlaygrounds.length > 0 
      ? _.orderBy(filteredPlaygrounds, [this.state.orderBy], [this.state.order])
      : [];
    
    return (
      <AdminPageShell title="Площадки">
        <div className={classes.pageBody}>
        {(isAdmin || isModerator) ? (
          <div className={classes.buttonBar}>
            {uniqueCities.length > 0 && (
              <Select
                value={this.state.cityFilter}
                onChange={event => this.setState({ cityFilter: event.target.value })}
                input={<Input id="city-filter" />}
                style={{ marginRight: '16px' }}
              >
                <MenuItem value="all">
                  <em>Все города</em>
                </MenuItem>
                {uniqueCities.map(city => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
            )}
            <Button to="/new-playground" variant="contained" color="primary" component={Link} className={classes.button}>
              Новая площадка
            </Button>
          </div>
        ) : (
          <div className={classes.emptyBar} />
        )}
        <Paper className={classes.paper} elevation={2}>
          {orderedPlaygrounds.length === 0 ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              Нет данных о площадках
            </div>
          ) : (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.orderBy === 'name'}
                      direction={this.state.order}
                      onClick={() => this.orderBy('name')}
                    >
                      Название
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.orderBy === 'center'}
                      direction={this.state.order}
                      onClick={() => this.orderBy('center')}
                    >
                      Спортивный центр
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.orderBy === 'city'}
                      direction={this.state.order}
                      onClick={() => this.orderBy('city')}
                    >
                      Город
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.orderBy === 'sport'}
                      direction={this.state.order}
                      onClick={() => this.orderBy('sport')}
                    >
                      Вид спорта
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderedPlaygrounds.map(n => (
                  <TableRow
                    className={classes.tableRow}
                    key={n.id}
                    onClick={() => this.redirectToPlayground(n.id)}
                  >
                    <TableCell>{n.name}</TableCell>
                    <TableCell>{n.center}</TableCell>
                    <TableCell>{n.city || 'Не указан'}</TableCell>
                    <TableCell>{n.sport && n.sport.join(', ')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Paper>
        </div>
      </AdminPageShell>
    );
  }
}

const styles = (theme) => ({
  pageBody: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: 1,
    minHeight: 0,
  },
  paper: {
    width: '100%',
    overflowX: 'auto',
    flex: 1,
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  buttonBar: {
    height: 67,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  emptyBar: {
    height: 15,
  },
  tableRow: {
    cursor: 'pointer',
  },
  table: {
    '& thead th': {
      backgroundColor: '#f8f9fa',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
    },
    '& tbody tr': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    '& tbody td': {
      borderBottom: '1px solid #e9ecef',
      padding: theme.spacing(1.5),
    },
  },
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
});

const Styled = withStyles(styles)(Playgrounds);
export default connect(
  state => ({
    playgrounds: listPLaygrounds(state),
    userRole: state.auth.role,
  }),
  { fetchPlaygrounds }
)(Styled);
